const journeyRecordsPages = {
    GridEmpresasJornada: import(
        "./jornada/cadastros/empresa/gridEmpresas/GridEmpresasJornada.js"
    ),
    GridMotoristasJornada: import(
        "./jornada/cadastros/motorista/GridMotoristasJornada.js"
    ),
    GridMotoristasTecnologia: import(
        "./jornada/cadastros/motorista/GridMotoristasTecnologia.js"
    ),
    GridVeiculosJornada: import(
        "./jornada/cadastros/veiculo/GridVeiculosJornada.js"
    ),
    GridEscalasJornada: import(
        "./jornada/cadastros/empresa/escala/GridEscalasJornada.js"
    ),
    CadastroArvoreDecisao: import(
        "./jornada/cadastros/arvoreDecisao/CadastroArvoreDecisao.tsx"
    ),
    GridServicosJornada: import(
        "./jornada/cadastros/servicos/GridServicosJornada.js"
    ),
    NovidadesSistema: import("./jornada/cadastros/novidades/"),
};

// Jornada de Terceiros
const outsourcedJourneyPages = {
    CadastroEmbarcadores: import("./jornadaTerceiros/cadastro/embarcador/"),
    ControleJornadaTerceirosTab: import("./jornadaTerceiros/controle/"),
    ControlePontuacaoPenalidadeTab: import(
        "./jornadaTerceiros/controle-pontuacao-penalidade/"
    ),
    GestaoViagensJornadaTerceiros: import(
        "./jornadaTerceiros/gestaojornada/viagens/"
    ),
    ManutencaoJornadaTerceiros: import(
        "./jornadaTerceiros/gestaojornada/manutencaoJornada/"
    ),
    RelatorioNaoConformidadesTerceiros: import(
        "./jornadaTerceiros/relatorios/NaoConformidadesTerceiros/"
    ),
    RelatorioJornadaTerceiros: import(
        "./jornadaTerceiros/relatorios/RelatorioJornadaTerceiros/"
    ),
};

const journeyReportsPages = {
    CartaoPontoSintetico: import(
        "./jornada/relatorios/CartaoPontoSintetico/CartaoPontoSintetico.js"
    ),
    ComprovantesRegistroPonto: import(
        "./jornada/relatorios/ComprovantesRegistroPonto/"
    ),
    CartaoPontoSinteticoAntigo: import(
        "./jornada/relatorios/CartaoPontoSintetico/CartaoPontoSinteticoAntigo.js"
    ),
    CartaoPontoSinteticoGo: import(
        "./jornada/relatorios/CartaoPontoSintetico/CartaoPontoSinteticoGo.js"
    ),
    GridListaDeRelatorios: import(
        "./jornada/relatorios/GridListaDeRelatorios.js"
    ),
    RelatorioAfastamentos: import(
        "./jornada/relatorios/RelatorioAfastamentos/"
    ),
    RelatorioKmDiariosMotoristas: import(
        "./jornada/relatorios/RelatorioKmDiariosMotoristas/"
    ),
    RelatorioAcessos: import("./jornada/relatorios/RelatorioAcessos.js"),
    RelatorioHorasFalta: import("./jornada/relatorios/RelatorioHorasFalta/"),
    RelatorioAtivacaoMotoristas: import(
        "./jornada/relatorios/RelatorioAtivacaoMotoristas/"
    ),
    RelatorioDSR: import("./jornada/relatorios/RelatorioDSR/"),
    RelatorioFaltaDescansoRepouso: import(
        "./jornada/relatorios/RelatorioFaltaDescansoRepouso/"
    ),
    RelatorioEventos: import("./jornada/relatorios/RelatorioEventos/"),
    RelatorioOcorrencias: import("./jornada/relatorios/RelatorioOcorrencias/"),
    RelatorioProdutividade: import(
        "./jornada/relatorios/RelatorioProdutividade/"
    ),
    RelatorioAnomalias: import("./jornada/relatorios/RelatorioAnomalias/"),
    RelatorioNaoConformidades: import(
        "./jornada/relatorios/RelatorioNaoConformidades/"
    ),
    RelatorioAlteracoesViaMobile: import(
        "./jornada/relatorios/RelatorioAlteracoesViaMobile/"
    ),
    RelatorioDiarias: import("./jornada/relatorios/RelatorioDiarias/"),
    RelatorioMensagensJornada: import(
        "./jornada/relatorios/RelatorioMensagensJornada/"
    ),
    RelatorioBancoDeHoras: import(
        "./jornada/relatorios/RelatorioBancoDeHoras/"
    ),
    RelatorioExcecoes: import("./jornada/relatorios/RelatorioExcecoes/"),
    RelatorioTratativaExcecoes: import(
        "./jornada/relatorios/RelatorioTratativaExcecoes"
    ),
    RelatorioAnotacoesJornada: import(
        "./jornada/relatorios/RelatorioAnotacoesJornada"
    ),
    RelatorioLogsAplicativo: import(
        "./jornada/relatorios/RelatorioLogsAplicativo/"
    ),
    RelatorioAlteracoesManuaisEventos: import(
        "./jornada/relatorios/RelatorioAlteracoesManuaisEventos/"
    ),
};

const journeyManagementPages = {
    GridControleJornada: import(
        "./jornada/gestaojornada/GridControleJornada.js"
    ),
    GridControleJornada2: import(
        "./jornada/gestaojornada/GridControleJornada2.js"
    ),
    GridControleJornadaGo: import(
        "./jornada/gestaojornada/GridControleJornadaGo.js"
    ),
    AssinaturaEletronica: import("./jornada/AssinaturaEletronica/"),
    ChatAssistenteIA: import("./jornada/gestaojornada/chat/"),
    JornadaAssistida: import("./jornada/jornadaAssistida/"),
    ManutencaoJornada: import(
        "./jornada/gestaojornada/manutencaoJornadaNova/"
    ),
};

const journeyMiscPages = {
    Inicio: import("./Inicio/"),
    Dashboards: import("./Dashboards/"),
    SystemIndicatorsManagement: import("./SystemIndicatorsManagement/"),
    IndicatorSectionsManagement: import("./IndicatorSectionsManagement/"),
    TelaCadastroBIJornada: import(
        "./jornada/businessIntelligence/TelaCadastroBIJornada.js"
    ),
    TelaPaineisBIJornada: import(
        "./jornada/businessIntelligence/TelaPaineisBIJornada.js"
    ),
    TelaVisaoBIJornada: import(
        "./jornada/businessIntelligence/TelaVisaoBIJornada.js"
    ),
};

const journeyConfigrationPages = {
    TelasSistema: import("./jornada/configuracoes/TelasSistema/"),
    MenusSistema: import("./jornada/configuracoes/MenusSistema/"),
    UsuariosSistema: import("./jornada/configuracoes/UsuariosSistema/"),
    PlanosSistema: import("./jornada/configuracoes/PlanosSistema/"),
    VinculosEmpresaPlano: import(
        "./jornada/configuracoes/VinculosEmpresaPlano/"
    ),
    PermissoesSistema: import("./jornada/configuracoes/PermissoesSistema/"),
    PermissoesSistemaPorUsuario: import(
        "./jornada/configuracoes/PermissoesSistemaPorUsuario/"
    ),
    GruposEmpresas: import("./jornada/configuracoes/GruposEmpresas/"),
    VinculosEmbarcadoraPlano: import(
        "./jornada/configuracoes/VinculosEmbarcadoraPlano/"
    ),
    ConfiguracoesMensagensAutomaticas: import(
        "./jornada/configuracoes/ConfiguracoesMensagensAutomaticas/"
    ),
    HistoricoConfiguracoesJornada: import(
        "./jornada/configuracoes/HistoricoConfiguracoesJornada/"
    ),
};

export default {
    ...journeyRecordsPages,
    ...journeyReportsPages,
    ...journeyManagementPages,
    ...journeyMiscPages,
    ...journeyConfigrationPages,
    ...outsourcedJourneyPages,
};
